{
  "INTEGRATION_APPS": {
    "FETCHING": "Pobieranie integracji",
    "NO_HOOK_CONFIGURED": "W tym koncie nie skonfigurowano integracji {integrationId}.",
    "HEADER": "Aplikacje",
    "COUNT": "{n} integration | {n} integrations",
    "SEARCH_PLACEHOLDER": "Search...",
    "NO_RESULTS": "No results found matching your search",
    "STATUS": {
      "ENABLED": "Włączone",
      "DISABLED": "Wyłączone"
    },
    "CONFIGURE": "Skonfiguruj",
    "ADD_BUTTON": "Dodaj nowy hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Potwierdzenie usunięcia",
        "ACCOUNT": "Rozłącz"
      },
      "MESSAGE": {
        "INBOX": "Czy na pewno chcesz usunąć?",
        "ACCOUNT": "Czy na pewno chcesz się rozłączyć?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Tak, usuń",
        "ACCOUNT": "Tak, rozłącz"
      },
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "API": {
        "SUCCESS_MESSAGE": "Hook został pomyślnie usunięty",
        "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot, spróbuj ponownie później"
      }
    },
    "LIST": {
      "FETCHING": "Pobieranie hooków integracyjnych",
      "INBOX": "Skrzynka odbiorcza",
      "ACTIONS": "Akcje",
      "DELETE": {
        "BUTTON_TEXT": "Usuń"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Wybierz skrzynkę odbiorczą",
          "PLACEHOLDER": "Wybierz skrzynkę odbiorczą"
        },
        "SUBMIT": "Dodaj",
        "VALIDATING_OPENAI": "Validating with OpenAI...",
        "CANCEL": "Anuluj"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook integracyjny został pomyślnie dodany",
        "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot, spróbuj ponownie później"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Połącz"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Rozłącz"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details"
    }
  }
}
